import 'unorm';

export const PROJECT = 'PROJECT';
export const BID = 'BID';
export const PUNCHLIST = 'PROJECT/PUNCHLIST';
export const RFI = 'PROJECT/RFI';
export const TASK = 'PROJECT/TASK';
export const SUBMITTAL = 'PROJECT/SUBMITTAL';
export const DAILYLOG = 'PROJECT/DAILYLOG';
export const MEETINGMINUTES = 'PROJECT/MEETINGMINUTES';

export function statusOk(status) {
  return (status >= 200 && status < 300);
}



// WEBPACK FOOTER //
// ./src/services/index.js